import { render, staticRenderFns } from "./argument.vue?vue&type=template&id=b5df184e&style=height%3A100%25"
import script from "./argument.vue?vue&type=script&lang=js"
export * from "./argument.vue?vue&type=script&lang=js"
import style0 from "./argument.vue?vue&type=style&index=0&id=b5df184e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports